export const phoneImg = {
  src: '/new/about-app/phone.png',
};

export const cards = [
  {
    id: 1,
    screen: { src: '/new/about-app/screen_1.png' },
  },
  {
    id: 2,
    screen: { src: '/new/about-app/screen_2.png' },
  },
  {
    id: 3,
    screen: { src: '/new/about-app/screen_3.png' },
  },
  {
    id: 4,
    screen: { src: '/new/about-app/screen_4.png' },
  },
];
